import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../app/services/aha-api";
const initialState = {
  value: [],
  loading: false,
};

export const getFacility = createAsyncThunk(
  "facility/getFacility",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.getFacility(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });

    return response;
  }
);

export const facilitySlice = createSlice({
  name: "facility",
  initialState,
  reducers: {
    setFacilityList(state, action) {
      state.value = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFacility.pending, (state) => {
        state.loading = true;
      })
      .addCase(getFacility.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(getFacility.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const facility = (state) => state.facility.value;
export const facilityObjLoader = (state) => state.facility.loading;
export const { setFacilityList } = facilitySlice.actions;

export default facilitySlice.reducer;
